// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"44801399","453":"0780540a","455":"76e809b0","977":"690e13f1"}[chunkId] + ".chunk.js";
};